<template>
  <div class="historyData">
    <sirui-table
      ref="siruiTable"
      :buttonList="[]"
      :loading="false"
      :data="tableData"
      :paging="true"
      :height="heightTree"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :fixed="item.fixed"
        :width="item.width"
        :sortable="item.sortable"
        :field="item.prop"
        :title="item.label"
      ></vxe-table-column>
    </sirui-table>
  </div>
</template>
<script>
  import SiruiTable from '@/components/SiruiTable';
  import API from '@/api/masterData/company.js';
  export default {
    name: 'historyData',
    components: {
      SiruiTable,
    },
    data() {
      return {
        tableData: [],
      };
    },
    computed: {
      columnList() {
        return [
          {
            prop: 'gmtCreate',
            label: this.$t('table.time'),
          },
          {
            prop: 'updateContent',
            label: this.$t('table.remark'),
          },
        ];
      },
      heightTree() {
        return window.innerHeight - 290 + 'px';
      },
    },
    methods: {
      getData(className, dataNo) {
        this.className = className;
        this.dataNo = dataNo;
        this.getHistoryList();
      },
      getHistoryList() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        const params = {
          className: this.className,
          dataNo: this.dataNo,
          pageNum,
          pageSize,
        };
        this.$axios.post(API.GET_HISTORY_LIST, params).then((res) => {
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 修改每页条数
      handleSizeChange() {
        this.getHistoryList();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getHistoryList();
      },
    },
  };
</script>
